import * as bootstrap from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export function showToast(
  message,
  type = "success",
  delay = 3000,
  autohide = true,
) {
  let container = document.getElementById("toast-container");
  if (!container) {
    container = document.createElement("div");
    container.id = "toast-container";
    container.className = "toast-container position-fixed ";
    document.body.appendChild(container);
  }

  const toastEl = document.createElement("div");
  toastEl.className = `toast align-items-center text-bg-${type} border-0`;
  toastEl.setAttribute("role", "alert");
  toastEl.setAttribute("aria-live", "assertive");
  toastEl.setAttribute("aria-atomic", "true");
  toastEl.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">${message}</div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>
  `;
  container.appendChild(toastEl);
  // 初始化並顯示 Toast,根據 autohide 參數決定是否自動關閉
  const toast = new bootstrap.Toast(toastEl, {
    delay,
    autohide: autohide,
  });
  toast.show();
  // 移除結束後的 DOM
  toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove());
}
